<div class="bottomSheetContainer">
  <div class="button">
    <div class="btn-ln" (click)="dismiss()">
      <div class="line"></div>
      <h4><img class="img-abono" src="/assets/images/icons/play-detail/abono-play-full.svg">Suscripción</h4>
    </div>
  </div>

  <div class="container">
    <div class="abono-container">
      <div class="abono-info">
        <span>{{ texto }}</span>

        @if (aviso != '') {
          <span class="aviso">{{ aviso }}</span>
        }

        @if (guinda != '') {
          <span class="guinda">{{ guinda }}</span>
        }
      </div>

      <div class="options-container">
        <div class="boton-abono" [ngClass]="{'selected': !random}" (click)="random = false">Mismos números</div>
        <div class="boton-abono" [ngClass]="{'selected': random}" (click)="random = true">Aleatorio</div>
      </div>

      <div class="flex">
        <button class="boton-cancelar" (click)="dismiss()">Cancelar</button>
        <button class="boton-abonarse" (click)="suscribirse()">Suscribirse</button>
      </div>
    </div>
  </div>
</div>
